import React from 'react';
import { Col, Button, ButtonToolbar, Row, ListGroupItem } from 'react-bootstrap';
import { loadTreeFromDb, deleteTableFromDb } from '../../../action/tableActions';
import { addNotification } from '../../../action/notificationAction';
import { FaCheck, FaMinus } from 'react-icons/fa';

function TableEntity(props) {

    let loader = () => {
        addNotification({ status: "success", message: `Loading ${props.tableTitle} ...` });
        loadTreeFromDb(props.id);
        props.hide();
    }
    let deleteClick = () => {
        addNotification({ status: "removing", message: `Removing ${props.tableTitle} ...` })
        deleteTableFromDb(props.id);
        props.hide();
    }
    
    return (
        <div key={props.id}>
            <ListGroupItem >
                <Row>

                    <Col xs={8}>
                        {props.tableTitle}

                    </Col>
                    <Col xs={4}>
                        <ButtonToolbar>
                            <Button onClick={loader}>
                                <FaCheck />
                            </Button>
                            <Button onClick={deleteClick} >
                                <FaMinus />
                            </Button>
                            
                        </ButtonToolbar>
                    </Col>
                </Row>

            </ListGroupItem>
        </div>
    )
}

export default TableEntity;


// WEBPACK FOOTER //
// ./src/components/tree/treeHeader/tableEntity.js